import { CoachServices } from '@/features/coach/services';
import { useMutation } from '@tanstack/react-query';

export const useMutateInactiveFilterDefault = () => {
  return useMutation({
    mutationFn: (request: { coachId: string; inactiveFilterLevel: number }) =>
      CoachServices.setInactiveFilterDefault(request),
  });
};
